import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { CellContext } from '@tanstack/react-table';

export interface EmspBoRfidBadgeOrderListQuantityCellProps
  extends CellContext<
    BackOfficeRfidBadgeOrderModel,
    BackOfficeRfidBadgeOrderModel['quantity']
  > {}

export const EmspBoRfidBadgeOrderListQuantityCell = (
  props: EmspBoRfidBadgeOrderListQuantityCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <span>{getValue()}</span>;
};
